import { useEffect, useRef, useState } from "react";
import classes from "./offline-warning.module.css";

const isOffline = () => !navigator.onLine;

export function OfflineWarning() {
	const [offline, setOffline] = useState(isOffline);
	const dialog = useRef<HTMLDialogElement>(null);

	useEffect(() => {
		const onOnline = () => {
			setOffline(false);
		};

		const onOffline = () => {
			setOffline(true);
		};

		window.addEventListener("online", onOnline);
		window.addEventListener("offline", onOffline);
		return () => {
			window.removeEventListener("online", onOnline);
			window.removeEventListener("offline", onOffline);
		};
	}, []);

	return (
		<dialog ref={dialog} className={classes.dialog} open={offline}>
			<svg className={classes.icon} viewBox="0 0 48 48">
				<title>Offline</title>
				<path d="M24 4C12.972 4 4 12.972 4 24s8.972 20 20 20c.979 0 1.94-.074 2.88-.21a12 12 0 0 1-1.849-2.946c-.345.104-.69.156-1.031.156-1.855 0-3.818-1.538-5.39-4.607-.643-1.255-1.188-2.746-1.618-4.393h7.725a12 12 0 0 1 1.572-3h-9.914a33.45 33.45 0 0 1 0-10h15.25A33.45 33.45 0 0 1 32 24c0 .243-.008.482-.014.723a12 12 0 0 1 3.012-.65L35 24a34.91 34.91 0 0 0-.363-5h5.617c.484 1.58.746 3.259.746 5 0 .362-.019.72-.041 1.076a12 12 0 0 1 2.832 1.801c.136-.94.209-1.9.209-2.877 0-11.028-8.972-20-20-20zm0 3c1.855 0 3.818 1.538 5.39 4.607.643 1.255 1.188 2.746 1.618 4.393H16.992c.43-1.647.975-3.138 1.617-4.393C20.182 8.538 22.145 7 24 7zm-6.629 1.336a16.422 16.422 0 0 0-1.416 2.236c-.84 1.59-1.511 3.427-2.008 5.428H9a17.006 17.006 0 0 1 8.371-7.664zm13.258 0A17.006 17.006 0 0 1 39 16h-4.947c-.497-2-1.169-3.838-2.008-5.428-.425-.804-.9-1.553-1.416-2.236zM7.746 19h5.617A34.91 34.91 0 0 0 13 24c0 1.731.132 3.401.363 5H7.746A17.051 17.051 0 0 1 7 24c0-1.741.262-3.42.746-5zM36 26a10 10 0 0 0-10 10 10 10 0 0 0 10 10 10 10 0 0 0 10-10 10 10 0 0 0-10-10zm0 3a7 7 0 0 1 7 7 7 7 0 0 1-1.12 3.76l-9.64-9.64A7 7 0 0 1 36 29zM9 32h4.947c.497 2 1.169 3.838 2.008 5.428.425.804.9 1.553 1.416 2.236A17.006 17.006 0 0 1 9 32zm21.12.24 9.64 9.64A7 7 0 0 1 36 43a7 7 0 0 1-7-7 7 7 0 0 1 1.12-3.76z" />
			</svg>
		</dialog>
	);
}
